/* unplugin-vue-components disabled */import { render } from "./IndexPage.vue?vue&type=template&id=e9c079d6&scoped=true&lang=pug"
import script from "./IndexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=e9c079d6&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c079d6"]])

export default __exports__